module.exports = __webpack_public_path__ + "static/media/green-check-mark-verified-circle-16223.0623ba03.png";